<template>
  <tab
        :index="this.tab"
        :loginRequired="this.loginRequired"
        :iframeDisplay="true"
        :init="init"
    />
</template>

<script>
import BaseIframe from './baseIframe.vue';

export default {
    extends: BaseIframe,
    props: ['tabIndex'],
    head() {
        return {};
    },
    data() {
        return {
            tab: this.tabIndex,
            height: 0
        };
    },
    methods: {
        async getIframeUrl() {
            try {
                const result = await this.$urlApi.getAthenaVS();
                return result;
            } catch (error) {
                console.log(error);
            }
        }
    },
    mounted() {
    }
};
</script>
